import axios from 'axios';

export default class FilterService {

	public static selectorList() {
		return axios.get(`/filter/filter`);
	}
}
